import Listing from "../../Listing";
import React, { useEffect } from "react";
import Header from "../../../../layout/Header";
import Footer from "../../../../layout/Footer";
import { useDispatch, useSelector } from "react-redux";
import HeroSection from "../../../../layout/HeroSection";
import Loader from "../../../../components/other/Loader";
import { pageRoutes } from "../../../../routes/pageRoutes";
import { fetchlessonBatteries } from "../../../../redux/action/lessonsAction";
import SecureContent from "../../../../components/secureContent";

const Batteries = () => {
  const dispatch = useDispatch();
  const { batteriesList, isLoading } = useSelector(
    (state) => state?.lessonsReducer
  );

  useEffect(() => {
    dispatch(fetchlessonBatteries());
  }, []);

  if (isLoading) {
    return <Loader />;
  }

  return (
    <>
      <div>
      <SecureContent/>
      <Header />
        <HeroSection
          label={<h1 class="mb-3">{"Batteries"}</h1>}
          breadcrumbItems={[
            { name: "Home", path: `${pageRoutes?.home}/` },
            {
              name: "Electrical engineering and robot combat",
              path: pageRoutes?.lessons?.electricalEngineering,
            },
            { name: "Batteries", path: `${pageRoutes?.home}/` },
          ]}
        />

        <Listing contentData={batteriesList} color={"#36296c"} />

        <Footer />
      </div>
    </>
  );
};

export default Batteries;
